<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="pl-fl-roman">Dear Reader,</p>
<p class="pl-fl-roman">I’m so excited to welcome you to Gold Valley, Oregon, a small Gold Rush town nestled in the mountains, surrounded by ranch land. Where the cowboys are tough and hardworking—and they just need the right women to tame them.</p>
<p class="pl-fl-roman">In <em class="italic">Smooth-Talking Cowboy</em>, Olivia Logan is having a rough few months.</p>
<p class="pl-fl-roman">After a break-up she didn’t really want, she’s looking for a way to win her perfect boyfriend back—by enlisting the help of the most imperfect man she knows.</p>
<p class="pl-fl-roman">Luke Hollister is all wrong for the Princess of Gold Valley, but the two of them together somehow feels so right. And inconvenient lust might just turn into true love.</p>
<p class="pl-fl-roman">Happy reading!</p>
<p class="pl-fl-roman"><em class="italic">Maisey Yates</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dear_Reader.vue?45cf0ced